/* Modulo FAQ — accordion with smooth height transition + single/multi-open modes.
   Vanilla IIFE, lazy-init via window.moduloLazyInit when available. */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  function initSection(el) {
    if (el.dataset.faqBound === '1') return;
    el.dataset.faqBound = '1';

    var mode  = el.getAttribute('data-mode') === 'multi' ? 'multi' : 'single';
    var items = el.querySelectorAll('[data-modulo-faq-item]');

    function close(item) {
      var content = item.querySelector('[data-modulo-faq-content]');
      var trigger = item.querySelector('[data-modulo-faq-trigger]');
      item.classList.remove('modulo-faq__item--open');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (content) content.style.maxHeight = '0';
    }

    function open(item) {
      var content = item.querySelector('[data-modulo-faq-content]');
      var trigger = item.querySelector('[data-modulo-faq-trigger]');
      item.classList.add('modulo-faq__item--open');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      if (content) content.style.maxHeight = content.scrollHeight + 'px';
    }

    items.forEach(function (item) {
      var trigger = item.querySelector('[data-modulo-faq-trigger]');
      if (!trigger) return;

      trigger.addEventListener('click', function () {
        var isOpen = item.classList.contains('modulo-faq__item--open');

        if (mode === 'single' && !isOpen) {
          // close everything else first
          items.forEach(function (other) { if (other !== item) close(other); });
        }

        if (isOpen) close(item);
        else        open(item);
      });
    });

    // Recalc max-height on resize so wrapped answers don't get clipped.
    var resizeTimeout = null;
    window.addEventListener('resize', function () {
      if (resizeTimeout) clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function () {
        items.forEach(function (item) {
          if (!item.classList.contains('modulo-faq__item--open')) return;
          var content = item.querySelector('[data-modulo-faq-content]');
          if (content) content.style.maxHeight = content.scrollHeight + 'px';
        });
      }, 100);
    }, { passive: true });
  }

  function bootstrap() {
    if (window.moduloLazyInit) {
      window.moduloLazyInit('[data-modulo-faq]', initSection);
    } else {
      var els = document.querySelectorAll('[data-modulo-faq]');
      for (var i = 0; i < els.length; i++) initSection(els[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
